module.exports = __webpack_public_path__ + "static/media/aws.4f1c849b.webp";